import moment from "moment"
import pluralize from "pluralize"
import { get } from "lodash"
import { RadioButtonChecked } from "@mui/icons-material"
import { DATABASE_DATE_FORMAT } from "helpers/formatters/dates"
import Tooltip from "components/material/tooltip"
import { GRACE_PERIOD } from "../helpers"

function getStatus(nbDays) {
  if (nbDays < 0) {
    return "expired"
  }
  if (nbDays < 15) {
    return "urgent"
  }
  return ""
}

function getExpiration(expiration) {
  if (!expiration) { return null }
  const nbDaysFromToday = moment(expiration, DATABASE_DATE_FORMAT).diff(moment(), "days")
  let message
  // Negative numbers mean its expired
  if (nbDaysFromToday < 0) {
    message = "Subscription is expired"
    if (nbDaysFromToday >= -GRACE_PERIOD) {
      message = `${message} (${Math.abs(nbDaysFromToday)} ${pluralize("day", nbDaysFromToday)})`
    }
    // expires today
  } else if (nbDaysFromToday === 0) {
    message = "Subscription expires today"
    // Message is displayed only when the expiration date is within 30 days of today
  } else if (nbDaysFromToday <= 30) {
    message = `Subscription expires in ${nbDaysFromToday} ${pluralize("day", nbDaysFromToday)}`
  }

  return { status: getStatus(nbDaysFromToday), message }
}

// [TODO] [#184018795] JSX shouldn't be in selectors or models
export function getExpirationElement(dataset) {
  const expiration = get(dataset, "expiration")
  if (!expiration) { return null }

  const { status, message } = getExpiration(expiration)
  return message ? <span className="status">
    <Tooltip title={message}>
      <RadioButtonChecked
        fontSize="small"
        className={status}
      />
    </Tooltip>
  </span> : null
}
